export default {
  Get: {
    LOOKUP_DATA: "getLookupData",
    LOOKUP_DATA_ALL_LANGUAGE: "getLookupDataAllLanguage",
    LIST_TYPES_OF_PROPERTY: "getListTypesOfProperty",
    LIST_OF_PURPOSES: "getListOfPurposes",
    LIST_OF_GOALS: "getListOfGoals",
    LIST_OF_DURATION_TASKS: "getListOfDurationTasks",
    LIST_OF_STATUSES: "getListOfStatuses",
    LIST_OF_STATUS: "getListOfStatus",
    LIST_OF_RELATION_REVERSE_TYPES: "getListOfRelationReverseTypes",
    LIST_OF_PERSONFUNCTIONS: "getListOfPersonFunctions",
    LIST_OF_COMPANYDEPARTMENTS: "getListOfCompanyDepartments",
    LIST_OF_PERSON_PROPERTIES: "getListOfPersonProperties",
    LIST_OF_RELATION_TYPES: "getListOfRelationTypes",
    LIST_OF_PERSON_TYPES: "getListOfPersonTypes",
    LIST_TYPES_OF_DOCUMENT: "getListTypesOfDocument",
    LIST_PUBLISH_TYPES_OF_DOCUMENT: "getListOfDocumentPublish",
    LIST_OF_SITES: "getListOfSites",
    LIST_OF_SINCE_DATE: "getListOfSinceDate",
    LIST_OF_PROPERTY_SUBSTATUS: "getListOfPropertySubStatus",
    LIST_OF_PICTUREGROUP: "getListOfPictureGroups",
    LIST_OF_ROOM_LOOKUPS: "getListOfRoomLookups",
    LIST_OF_ROOM_FLOORS: "getListOfRoomFloors",
    LIST_OF_ROOM_DESCRIPTIONS: "getListOfRoomDescriptions",
    LIST_OF_ROOM_STATES: "getListOfRoomStates",
    LIST_OF_ROOM_COVERING: "getListOfRoomCovering",
    LIST_OF_ROOM_KEYWORDS: "getListOfRoomKeywords",
    LIST_OF_ORIENTATIONS: "getListOfOrientations",
    LIST_OF_ADMINISTRATION_LOOKUPS: "getListOfAdministrationLookups",
    LIST_OF_ADMINISTRATION_EPCBRUSSELS: "getListOfEPCBrussels",
    LIST_OF_ADMINISTRATION_GROUNDCERTIFICATE: "getListOfGroundCertificate",
    LIST_OF_ADMINISTRATION_OILTANKPLACEMENT: "getListOfOilTankPlacement",
    LIST_OF_ADMINISTRATION_OILTANKFURTHEREXPLOITATION:
      "getListOfOilTankFurtherExploitation",
    LIST_OF_ADMINISTRATION_OILTANKCERTIFICATEOFINSPECTION:
      "getListOfOilTankCertificateOfInspection",
    LIST_OF_ADMINISTRATION_ELECTRICITYIMMOWEB: "getListOfElectricityImmoWeb",
    LIST_OF_ADMINISTRATION_GASOLINEIMMOWEB: "getListOfGasolineImmoWeb",
    LIST_OF_ADMINISTRATION_PERMITOPTIONS: "getListOfPermitOptions",
    LIST_OF_ADMINISTRATION_AREAAPPLICATION: "getListOfAreaApplication",
    LIST_OF_ADMINISTRATION_HERITAGETYPE: "getListOfHeritageType",
    LIST_OF_ADMINISTRATION_FLOODRISK: "getListOfFloodRisk",
    LIST_OF_ADMINISTRATION_YESNO: "getListOfYesNo",
    LIST_OF_ASBESTOS_PLATFORM: "listOfAsbestosType",
    LIST_OF_ADMINISTRATION_FLOODZONE: "listOfFloodZoneType",
    LIST_OF_EMAIL_BY_PROPERTYIDS: "getlistOfEmailByPropertyIds",
    LIST_OF_FINANCE: "getListOfFinance",
    LIST_OF_MANWOMAN: "getListOfManWoman",
    LIST_OF_VIAGERTYPE: "getListOfViagerType",
    LIST_OF_REGISTERED_TYPE: "getListOfRegisteredType",
    LIST_OF_REGISTERED_TYPE_BRUSSELS: "getListOfRegisteredTypeBrussels",
    LIST_OF_REGISTERED_TYPE_WALLONIA: "getListOfRegisteredTypeWallonia",
    LIST_OF_REGISTERED_TYPE_FLANDERS: "getListOfRegisteredTypeFlanders",
    LIST_OF_REGISTERED_TYPE_NONE: "getListOfRegisteredTypeNone",
    LIST_OF_PUBLIC_UTILITIES: "getListOfPublicUtilites",
    LIST_OF_CHARGE_ELEMENTS: "getListOfChargeElements",
    // Property Environment
    LIST_OF_PROPERTY_ENVIRONMENT: "getListOfPropertyEnvironment",

    LIST_OF_CONDITION:"getListOfCondition",
    LIST_OF_CONSTRUCTION:"getListOfConstruction",
    LIST_OF_EXTERIORCOMFORT:"getListOfExteriorComfort",
    LIST_OF_GOAL:"getListOfGoal",
    LIST_OF_HEATING:"getListOfHeating",
    LIST_OF_HEATINGB:"getListOfHeatingB",
    LIST_OF_INTERIORCOMFORT:"getListOfInteriorComfort",
    LIST_OF_KITCHEN:"getListOfKitchen",
    LIST_OF_REARORIENTATION:"getListOfRearOrientation",
    LIST_OF_ROOFMATERIAL:"getListOfRoofMaterial",
    LIST_OF_ROOF:"getListOfRoof",
    LIST_OF_STYLE:"getListOfStyle",
    LIST_OF_ROOFCONDITION:"getListOfRoofCondition",
    LIST_OF_WINDOWSGLAZING:"getListOfWindowsGlazing",
    LIST_OF_WINDOWFRAME:"getListOfWindowFrame",

    //#region property-relation
    LIST_OF_MANDATETYPE: "getListOfMandateType",
    LIST_OF_PROLONGATIONTYPE: "getListOfProlongationType",
    LIST_OF_COMMISSIONTYPE: "getListOfCommissionType",
    LIST_OF_DEPOSITTYPE: "getListOfDepositType",
    LIST_OF_PERSONTYPE: "getListOfPersonType",
    LIST_OF_CONFIRMEMAILTIME: "getListOfConfirmEmailTime",
    LIST_OF_PARTICULARCONDITIONCLAUSE: "getListOfParticularConditionClause",
    LIST_OF_PREPAYMENTTYPE: "getListOfPrepaymentType",
    //#endregion
    
    LIST_OF_APPOINTMENT_TYPE: "getListOfAppointmentType",
    LIST_OF_APPOINTMENT_STATUS: "getListOfAppointmentStatus",
    APPOINTMENT_CONFIG: "getAppointmentConfig",
    LIST_OF_IMMOWEBOPTION: "getListOfImmoWebOption",
    LIST_OF_PUBLISH_ON_MEDIA: "getListOfPublishOnMedia",
    LIST_OF_PERSONAL_BY_AGENDA_ID: "listOfPersonalByAgendaId",
    LIST_TASK_GROUP: 'getTaskGroup',
    LIST_CANDIDATES: "getListCandidates",
    POSITIVE_COMMENTS: "PositiveInterest",
    NEGATIVE_COMMENTS: "NoInterestReason",

    LIST_PROPERTY_SITE: "listPropertySites",
    LIST_PERSON_SITE: "listPersonSites",
    LIST_DEMAND_SITE: "listDemandSites",
    LIST_COST_TYPE: "listCostTypes"
  },
  Set: {
    LOOKUP_DATA: "setLookupData",
    LIST_OF_ADDRESSTITLES: "setListOfAddressTitles",
    LIST_OF_C21PROFESSION: "setListOfC21Profession",
    LIST_OF_CATEGORIES: "setListOfCategories",
    LIST_OF_DURATION_TASKS: "setListOfDurationTasks",
    LIST_OF_GOALS: "setListOfGoals",
    LIST_OF_PURPOSES: "setListOfPurposes",
    LIST_OF_LETTERTITLES: "setListOfLetterTitles",
    LIST_OF_PERSONFUNCTIONS: "setListOfPersonFunctions",
    LIST_OF_COMPANYDEPARTMENTS: "setListOfCompanyDepartments",
    LIST_OF_MANAGERS: "setListOfManagers",
    LIST_OF_MARITALSTATUSES: "setListOfMaritalStatuses",
    LIST_OF_COUNTRIES1: "setListOfCountries1",
    LIST_OF_COUNTRIES2: "setListOfCountries2",
    LIST_OF_COUNTRIES3: "setListOfCountries3",
    LIST_OF_CITIES: "setListOfCities",
    LIST_OF_CITIES1: "setListOfCities1",
    LIST_OF_CITIES2: "setListOfCities2",
    LIST_OF_CITIES3: "setListOfCities3",
    LIST_OF_PERSON_DEMANDS: "setListOfPersonDemands",
    LIST_OF_PERSON_PROPERTIES: "setListOfPersonProperties",
    LIST_OF_PERSON_PROPOSALS: "setListOfPersonProposals",
    LIST_OF_PERSON_TYPES: "setListOfPersonTypes",
    LIST_OF_PHONE_DESCRIPTIONS: "setListOfPhoneDescriptions",
    LIST_OF_PREFERREDMEDIA: "setListOfPreferredMedia",
    LIST_OF_PRECONFIRMATIONS: "setListOfPreConfirmations",
    LIST_OF_PERSONSOURCES: "setListOfPersonSources",
    LIST_OF_RELATION_TYPES: "setListOfRelationTypes",
    LIST_OF_RELATION_REVERSE_TYPES: "setListOfRelationReverseTypes",
    LIST_OF_STATUSES: "setListOfStatuses",
    LIST_OF_STATUS: "setListOfStatus",
    LIST_OF_PROPERTY_SUBSTATUS: "setListOfPropertySubStatus",
    LIST_OF_SITES: "setListOfSites",
    LIST_OF_SINCE_DATE: "setListOfSinceDate",
    LIST_OF_TASK_TYPES: "setListOfTaskTypes",
    LIST_OF_TASK_GROUPS: "setListOfTaskGroups",
    LIST_TYPES_OF_PROPERTY: "setListTypesOfProperty",
    LIST_TYPES_OF_DOCUMENT: "setListTypesOfDocument",
    LIST_PUBLISH_TYPES_OF_DOCUMENT: "setListOfDocumentPublish",
    LIST_OF_PICTUREGROUP: "setListOfPictureGroups",
    LIST_OF_ROOM_FLOORS: "setListOfRoomFloors",
    LIST_OF_ROOM_DESCRIPTIONS: "setListOfRoomDescriptions",
    LIST_OF_ROOM_STATES: "setListOfRoomStates",
    LIST_OF_ROOM_COVERING: "setListOfRoomCovering",
    LIST_OF_ROOM_KEYWORDS: "setListOfRoomKeywords",
    LIST_OF_ORIENTATIONS: "setListOfOrientations",
    LIST_OF_ADMINISTRATION_LOOKUPS: "setListOfAdministrationLookups",

    LIST_OF_ADMINISTRATION_CO2_EMISSION: "setListOfCO2Emission",
    LIST_OF_ADMINISTRATION_INSULATION: "setListOfInsulation",
    LIST_OF_ADMINISTRATION_EPCLUXEMBOURG: "setListOfEPCLuxembourg",
    LIST_OF_ADMINISTRATION_EPCBRUSSELS: "setListOfEPCBrussels",
    LIST_OF_ADMINISTRATION_EPCIMMOWEB: "setListOfEPCImmoWeb",
    LIST_OF_ADMINISTRATION_EPCTYPE: "setListOfEPCType",
    LIST_OF_ADMINISTRATION_EPCNR: "setListOfEPCNR",
    LIST_OF_ADMINISTRATION_EPCkNR: "setListOfEPCkNR",
    LIST_OF_ADMINISTRATION_EPCFLANDERS: "setListOfEPCFlanders",
    LIST_OF_ADMINISTRATION_GROUNDCERTIFICATE: "setListOfGroundCertificate",
    LIST_OF_ADMINISTRATION_OILTANKPLACEMENT: "setListOfOilTankPlacement",
    LIST_OF_ADMINISTRATION_OILTANKFURTHEREXPLOITATION:
      "setListOfOilTankFurtherExploitation",
    LIST_OF_ADMINISTRATION_OILTANKCERTIFICATEOFINSPECTION:
      "setListOfOilTankCertificateOfInspection",
    LIST_OF_ADMINISTRATION_ELECTRICITYIMMOWEB: "setListOfElectricityImmoWeb",
    LIST_OF_ADMINISTRATION_GASOLINEIMMOWEB: "setListOfGasolineImmoWeb",
    LIST_OF_ADMINISTRATION_PERMITOPTIONS: "setListOfPermitOptions",
    LIST_OF_ADMINISTRATION_HAS_SUMMON: "setListOfHasSummon",
    LIST_OF_ADMINISTRATION_AREAAPPLICATION: "setListOfAreaApplication",
    LIST_OF_ADMINISTRATION_HERITAGETYPE: "setListOfHeritageType",
    LIST_OF_ADMINISTRATION_FLOODRISK: "setListOfFloodRisk",
    LIST_OF_ADMINISTRATION_FLOODZONE: "listOfFloodZoneType",
    LIST_OF_ADMINISTRATION_YESNO: "setListOfYesNo",
    LIST_OF_ASBESTOS_PLATFORM: "listOfAsbestosType",
    LIST_OF_EMAIL_BY_PROPERTYIDS: "setlistOfEmailByPropertyIds",
    LIST_OF_COMPANIES: "setlistOfCompanies",
    LIST_OF_MANWOMAN: "setListOfManWoman",
    LIST_OF_VIAGERTYPE: "setListOfViagerType",
    LIST_OF_REGISTERED_TYPE_BRUSSELS: "setListOfRegisteredTypeBrussels",
    LIST_OF_REGISTERED_TYPE_WALLONIA: "setListOfRegisteredTypeWallonia",
    LIST_OF_REGISTERED_TYPE_FLANDERS: "setListOfRegisteredTypeFlanders",
    LIST_OF_REGISTERED_TYPE_NONE: "setListOfRegisteredTypeNone",
    LIST_OF_PUBLIC_UTILITIES: "setListOfPublicUtilites",
    LIST_OF_CHARGE_ELEMENTS: "setListOfChargeElements",
    //#region common
    LIST_OF_COMMON_GOALS: "setlistOfCommonGoals",
    LIST_OF_COMMON_MANAGERS: "setlistOfCommonManagers",
    //#endregion

    //#region demand
    LIST_OF_DEMAND_STATUS: "setlistOfDemandStatus",
    LIST_OF_DEMAND_PURPOSES: "setlistOfDemandPurposes",
    //#endregion
    // Property Environment
    LIST_OF_PROPERTY_ENVIRONMENT: "getListOfPropertyEnvironment",

    LIST_OF_CONDITION:"setListOfCondition",
    LIST_OF_CONSTRUCTION:"setListOfConstruction",
    LIST_OF_EXTERIORCOMFORT:"setListOfExteriorComfort",
    LIST_OF_GOAL:"setListOfGoal",
    LIST_OF_HEATING:"setListOfHeating",
    LIST_OF_HEATINGB:"setListOfHeatingB",
    LIST_OF_INTERIORCOMFORT:"setListOfInteriorComfort",
    LIST_OF_KITCHEN:"setListOfKitchen",
    LIST_OF_REARORIENTATION:"setListOfRearOrientation",
    LIST_OF_ROOFMATERIAL:"setListOfRoofMaterial",
    LIST_OF_ROOF:"setListOfRoof",
    LIST_OF_STYLE:"setListOfStyle",
    LIST_OF_ROOFCONDITION:"setListOfRoofCondition",
    LIST_OF_WINDOWSGLAZING:"setListOfWindowsGlazing",
    LIST_OF_WINDOWFRAME:"setListOfWindowFrame",

    //#region property-relation
    LIST_OF_MANDATETYPE: "setListOfMandateType",
    LIST_OF_PROLONGATIONTYPE: "setListOfProlongationType",
    LIST_OF_COMMISSIONTYPE: "setListOfCommissionType",
    LIST_OF_DEPOSITTYPE: "setListOfDepositType",
    LIST_OF_PERSONTYPE: "setListOfPersonType",
    LIST_OF_CONFIRMEMAILTIME: "setListOfConfirmEmailTime",
    LIST_OF_PARTICULARCONDITIONCLAUSE: "setListOfParticularConditionClause",
    LIST_OF_PREPAYMENTTYPE: "setListOfPrepaymentType",
    STORED_LOOKUP_OBJECT: "storedLookupObject",
      REMOVE_LOOKUP_OBJECT_BY_KEY: "removeLookupObjectByKey",
    //#endregion

    LIST_OF_APPOINTMENT_TYPE: "setListOfAppointmentType",
    LIST_OF_APPOINTMENT_STATUS: "setListOfAppointmentStatus",
    APPOINTMENT_CONFIG: "setAppointmentConfig",
    APPOINTMENT_CONFIG_VALUE: "setAppointmentConfigValue",
    LIST_OF_IMMOWEBOPTION: "setListOfImmoWebOption",
    LIST_OF_PUBLISH_ON_MEDIA: "SetListOfPublishOnMedia",
    LIST_OF_PERSONAL_BY_AGENDA_ID: "listOfPersonalByAgendaId",
      LIST_CANDIDATES: "setListCandidates",
    
      
  }
};
